import { render } from "./RegistroInvitacionEmpresaView.vue?vue&type=template&id=4ea5d1b8&ts=true"
import script from "./RegistroInvitacionEmpresaView.vue?vue&type=script&lang=ts"
export * from "./RegistroInvitacionEmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__